<template>
  <div class="boast" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div
      v-for="(boast, index) of boastDatas"
      :key="index"
      class="boast-item"
      @click="
        $router.push({
          name: 'rtfPreview',
          params: boast,
        })
      "
    >
      <!-- <div class="boast-item-card">
        <el-image :src="boast.img" fit="cover" class="boast-item-card__img" />
      </div>-->
      <div class="boast-item-text">
        <div class="boast-item-card__title">{{ boast.title }}</div>

        <div class="boast-item-card__content">{{ boast.intro }}</div>

        <div
          style="
            float: right;
            font-size: 0.75rem;
            color: #409eff;
            cursor: pointer;
          "
        >
          更多详情
        </div>
      </div>
      <!-- <router-link
        :to="{
          name: 'rtfPreview',
          params: boast,
        }"
        tag="button"
        class="boast-item-button"
      >
        查看详情
      </router-link> -->
    </div>
    <div class="land-no" v-if="!boastDatas.length">
      <!-- 暂无数据 -->
      <div class="land-no-img">
        <img src="../../../assets/images/home/no-data1.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/13 09:51
 * @Description 区位优势、营商环境、产业聚集
 */
import { getAttractList, attractConfirm } from "@/api/setting/investment";

export default {
  name: "boast",
  props: {
    xzqh: {
      type: String,
      default: "53",
    },
  },
  data() {
    return {
      screenIndexWidth: null,
      defaultXzqh: "53",
      boastDatas: [],
    };
  },
  created() {
    this.getData(this.defaultXzqh);
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
  },
  watch: {
    xzqh(newValue, oldValue) {
      //只到市级
      if (newValue.length < 6) {
        this.getData(this.xzqh);
      }
      if (newValue.length == 6) {
        this.getCase();
      }
    },
  },
  methods: {
    getCase() {
      attractConfirm({ countyFlag: this.xzqh }).then((res) => {
        if (res.data.success && res.data.data) {
          this.getData(this.xzqh);
        } else {
          let xzqh = this.xzqh.substr(0, 4);
          this.getData(xzqh);
        }
      });
    },
    getData(xzqh) {
      getAttractList({
        countyFlag: xzqh,
      }).then(({ data: res }) => {
        if (res.success) {
          if (res.data.records?.length) {
            let record = res.data.records[0];
            let boast0 = {
              img: record.locationImages
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  (record.locationImages ?? [])[0]?.filePath
                : require("@/assets/images/home/advantage.png"),
              title: "区位优势",
              intro: this.transitionClean(record.locationAdvantage),
              content: record.locationAdvantage,
            };
            this.$set(this.boastDatas, 0, boast0);

            let boast1 = {
              img: record.businessImages
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  (record.businessImages ?? [])[0]?.filePath
                : require("@/assets/images/home/business.png"),
              title: "营商环境",
              intro: this.transitionClean(record.businessInvestment),
              content: record.businessInvestment,
            };
            this.$set(this.boastDatas, 1, boast1);

            let boast2 = {
              img: record.industryImages
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  (record.industryImages ?? [])[0]?.filePath
                : require("@/assets/images/home/industrial.png"),
              title: "产业聚集",
              intro: this.transitionClean(record.industryClustering),
              content: record.industryClustering,
            };
            this.$set(this.boastDatas, 2, boast2);
          } else {
            this.boastDatas = [];
          }
        }
      });
    },
    //去掉格式
    transitionClean(connet) {
      return connet.replace(/<(?!img|video).*?>/g, "");
    },
  },
};
</script>

<style scoped>
.boast {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 375px;
  /* column-gap: 2%; */
}

.boast-item {
  width: 100%;
  height: calc((100% - 40px) / 3);
  display: flex;
  /* flex-direction: column; */
}

.boast-item-card {
  background-color: #fcfcfc;
  border: 1px solid #dadada;
  overflow: hidden;
  width: 40%;
}
.boast-item-text {
  /*width: calc(60% - 20px);*/
  padding-left: 20px;
  letter-spacing: 2px;
}
.boast-item-card__img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.boast-item-card__title {
  padding-bottom: 8px;
  font-size: 1.1em;
  font-weight: bold;
  color: #386ed6;
}

.boast-item-card__content {
  line-height: 16px;
  color: #7c7c7c;
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  cursor: pointer;
}

.boast-item-button {
  color: white;
  width: 40%;
  height: 28px;
  align-self: center;
  position: relative;
  top: -14px;
  background-color: #d6ae73;
  border-radius: 14px;
  border-color: #d6ae73;
  border-width: 1px;
  cursor: pointer;
}

.land-no {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.land-no-img {
  width: 216px;
  height: 120px;
}
.land-no-img > img {
  width: 100%;
  height: 100%;
}
</style>
